export const BEGIN_PASSWORD_RECOVERY = 'BEGIN_PASSWORD_RECOVERY';
export const CANCEL_PASSWORD_RECOVERY = 'CANCEL_PASSWORD_RECOVERY';

export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const SUCCESS_RECOVER_PASSWORD = 'SUCCESS_RECOVER_PASSWORD';
export const FAILURE_RECOVER_PASSWORD = 'FAILURE_RECOVER_PASSWORD';

export const PHONE_RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const SUCCESS_PHONE_RECOVER_PASSWORD = 'SUCCESS_PHONE_RECOVER_PASSWORD';
export const FAILURE_PHONE_RECOVER_PASSWORD = 'FAILURE_PHONE_RECOVER_PASSWORD';



// WEBPACK FOOTER //
// ./js/actions/PasswordRecovery.js